import { render, staticRenderFns } from "./FilterTreatment.vue?vue&type=template&id=126eb7b0&scoped=true&lang=pug&"
import script from "./FilterTreatment.vue?vue&type=script&lang=js&"
export * from "./FilterTreatment.vue?vue&type=script&lang=js&"
import style0 from "./FilterTreatment.vue?vue&type=style&index=0&id=126eb7b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126eb7b0",
  null
  
)

export default component.exports